export class WorkflowConstants {
    static readonly SCANNED = 'scanned';
    static readonly AAPVERIFY = 'aapverify';
    static readonly AAPSUPERVISOR = 'aapsupervisor';
    static readonly CAMINBOX = 'caminbox';
    static readonly CAMINREVIEW = 'caminreview';
    static readonly ACCTINBOX = 'acctinbox';
    static readonly ACCTINREVIEW = 'acctinreview';
    static readonly DENIED = 'denied';

    static readonly CAM_STEP = 'cam';
    static readonly ACCOUNTANT_STEP = 'acct';
    static readonly HOLD = 'hold';

    static readonly APPROVED = 'approved';
    static readonly BOARD_APPROVAL = 'boardapproval';

    static readonly OPEN_STATUS = 'open';
    static readonly DELETE_STATUS = 'deleted';

    static readonly EMPTY_ADDRESS = '<br/><br/>';

    static readonly FIELD_COMMUNITY = 'Community';
    static readonly FIELD_PAYEE_TYPE = 'Payee Type';
    static readonly FIELD_PAYEE = 'Payee';
    static readonly FIELD_VENDOR_ACNT = 'Vendor Account';
    static readonly FIELD_INVOICE_DT = 'Invoice Date';
    static readonly FIELD_DUE_DT = 'Due Date';
    static readonly FIELD_DESC = 'Description';
    static readonly FIELD_INVOICE_AMT = 'Invoice Amount';
    static readonly FIELD_AMT_TO_PAY = 'Amount To Pay';
    static readonly FIELD_INVOICE_NUM = 'Invoice Number';
    static readonly FIELD_EFT_ACCNT = 'EFT';
    static readonly FIELD_LATE_FEE = 'Late Fee';
    static readonly FIELD_SPECIAL_HANDLING = 'Special Handling';

    static readonly PAYEE_TYPE_VENDOR = 'vendor';
    static readonly PAYEE_TYPE_COMMUNITY = 'community';
    static readonly PAYEE_TYPE_OWNER = 'owner';
}
